import styled from "styled-components";

export const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  margin: "0 0 24px",
});
